import { recordClick, recordImpression } from '@paypalcorp/fpti-tracker';
import { extend, get } from 'lodash';

export class FptiHelper {
  constructor(options) {
    const { app, experimentation, defaultFptiOptions } = options;
    this.fptiObject = {
      pgrp: get(
        defaultFptiOptions,
        'pgrp',
        'main:businessweb:mep:dashboard:main'
      ),
      ...experimentation.quiz
    };
    this.options = {
      custId: get(app, 'custId', ''),
      acnt: 'Business',
      flfr: 'Home',
      comp: 'merchanthubnodeweb',
      acct_cntry: get(app, 'legalCountry', '')
    };
    this.defaultFptiOptions = defaultFptiOptions;
  }

  fptiClick(fptiOptions) {
    const {
        link,
        prod,
        product_type,
        optsel,
        survey_name,
        survey_data
      } = fptiOptions,
      fptiObject = Object.assign(
        this.getOverrides(fptiOptions),
        this.fptiObject
      ),
      options = Object.assign({ link }, this.options);

    if (prod) extend(options, { prod });
    if (product_type) extend(options, { product_type });
    if (optsel) extend(options, { optsel });
    if (survey_name) extend(options, { survey_name });
    if (survey_data) extend(options, { survey_data });

    recordClick(options, fptiObject);
  }

  fptiImpression(fptiOptions) {
    const fptiObject = Object.assign(
        this.getOverrides(fptiOptions),
        this.fptiObject
      ),
      options = Object.assign({}, this.options);

    recordImpression(options, fptiObject);
  }

  getOverrides(fptiOptions) {
    const { page, entry_point, flow } = fptiOptions;
    return {
      page: page || get(this.defaultFptiOptions, 'page', ''),
      entry_point: entry_point ? 'appcenter' : 'home',
      flow: flow || get(this.defaultFptiOptions, 'flow', '')
    };
  }
}
